import React from 'react';

const shimmer = "animate-pulse bg-gradient-to-r from-[#2A2A2A] via-[#333333] to-[#2A2A2A] rounded-lg";

export const MatchSkeleton = () => (
  <div className="space-y-3 px-4" data-testid="match-skeleton">
    {[...Array(3)].map((_, g) => (
      <div key={g}>
        <div className={`h-5 w-40 ${shimmer} mb-2`} />
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-center justify-between py-3 px-3 bg-[#1E1E1E] rounded-xl mb-2">
            <div className="flex items-center gap-2 flex-1">
              <div className={`w-6 h-6 rounded-full ${shimmer}`} />
              <div className={`h-4 w-24 ${shimmer}`} />
            </div>
            <div className={`h-5 w-12 ${shimmer}`} />
            <div className="flex items-center gap-2 flex-1 justify-end">
              <div className={`h-4 w-24 ${shimmer}`} />
              <div className={`w-6 h-6 rounded-full ${shimmer}`} />
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export const VIPSkeleton = () => (
  <div className="space-y-4 px-4" data-testid="vip-skeleton">
    {[...Array(2)].map((_, i) => (
      <div key={i} className="bg-[#1E1E1E] rounded-2xl p-4 border border-gray-800">
        <div className="flex justify-between items-center mb-3">
          <div className={`h-5 w-32 ${shimmer}`} />
          <div className={`h-6 w-20 rounded-full ${shimmer}`} />
        </div>
        <div className={`h-40 w-full ${shimmer} mb-3`} />
        <div className={`h-4 w-48 ${shimmer} mb-2`} />
        <div className={`h-4 w-36 ${shimmer}`} />
      </div>
    ))}
  </div>
);

export const ChatSkeleton = () => (
  <div className="space-y-2 px-4" data-testid="chat-skeleton">
    {[...Array(5)].map((_, i) => (
      <div key={i} className="flex items-center gap-3 py-3 px-3 bg-[#1E1E1E] rounded-xl">
        <div className={`w-10 h-10 rounded-full ${shimmer} flex-shrink-0`} />
        <div className="flex-1 space-y-2">
          <div className={`h-4 w-28 ${shimmer}`} />
          <div className={`h-3 w-48 ${shimmer}`} />
        </div>
        <div className={`h-3 w-10 ${shimmer}`} />
      </div>
    ))}
  </div>
);

export const BonusSkeleton = () => (
  <div className="space-y-3 px-4" data-testid="bonus-skeleton">
    {[...Array(4)].map((_, i) => (
      <div key={i} className="bg-[#1E1E1E] rounded-2xl p-4 flex items-center gap-4">
        <div className={`w-16 h-16 rounded-xl ${shimmer} flex-shrink-0`} />
        <div className="flex-1 space-y-2">
          <div className={`h-5 w-32 ${shimmer}`} />
          <div className={`h-4 w-20 ${shimmer}`} />
          <div className={`h-3 w-44 ${shimmer}`} />
        </div>
      </div>
    ))}
  </div>
);

export const MessagesSkeleton = () => (
  <div className="space-y-3 px-4 py-4" data-testid="messages-skeleton">
    {[...Array(6)].map((_, i) => (
      <div key={i} className={`flex ${i % 3 === 0 ? 'justify-end' : 'justify-start'}`}>
        <div className={`${shimmer} rounded-2xl p-3`} style={{ width: `${45 + (i * 7) % 35}%`, height: `${28 + (i * 5) % 20}px` }} />
      </div>
    ))}
  </div>
);

export const GenericSkeleton = ({ lines = 5 }) => (
  <div className="space-y-3 px-4">
    {[...Array(lines)].map((_, i) => (
      <div key={i} className={`h-4 ${shimmer}`} style={{ width: `${60 + (i * 13) % 35}%` }} />
    ))}
  </div>
);
